import React, { useState, useEffect, useContext } from 'react';
import { useSwipeable } from 'react-swipeable';

import { Context } from '@store/store';
import {
  StyledPageContainer,
  StyledPagesContainer,
} from './page-container.styles';
import PageFrame from './page-frame';
import { isZoomScaleEqualsToOne } from './utils';

const PageContainer = ({ pages, bookId }) => {
  const [state, dispatch] = useContext(Context);
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [pageHTML, setPageHTML] = useState(null);

  const swipeHandlers = useSwipeable({
    onSwipedRight: () => {
      if (isZoomScaleEqualsToOne()) dispatch({ type: 'SET_PREV_PAGE' });
    },
    onSwipedLeft: () => {
      if (isZoomScaleEqualsToOne()) dispatch({ type: 'SET_NEXT_PAGE' });
    },
  });

  useEffect(() => {
    const fetchPages = async () => {
      setIsPageLoading(true);
      await fetch(pages[state.currentPage])
        .then(res => {
          return res.text();
        })
        .then(data => {
          setPageHTML(data);
        })
        .finally(() => {
          setIsPageLoading(false);
        });
    };

    fetchPages();
  }, [state.currentPage]);

  return (
    <StyledPageContainer id="page-container">
      {isPageLoading ? (
        <p
          style={{
            margin: 'auto',
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          Загрузка...
        </p>
      ) : (
        <StyledPagesContainer {...swipeHandlers}>
          <PageFrame pageFrameTags={pageHTML} bookId={bookId} />
        </StyledPagesContainer>
      )}
    </StyledPageContainer>
  );
};

export default PageContainer;
